export default function() {
  return data[process.env.VUE_APP_TOUCHPOINT_DATA_SET];
}
let data = {
  wall: {
    zoneOne: {
      fiveByOne: [
        {
          touchPointPosition: { top: "30%", left: "0%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "buildingOneAnimation"
        },
        {
          touchPointPosition: { top: "20%", left: "0%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "buildingOneAnimationTwo"
        }
      ],
      sixteenByNine: [
        {
          touchPointPosition: { top: "40%", left: "0%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "buildingOneAnimation"
        },
        {
          touchPointPosition: { top: "40%", left: "0%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "buildingOneAnimationTwo"
        }
      ]
    },
    zoneTwo: {
      fiveByOne: [
        {
          touchPointPosition: { top: "5%", left: "0%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "EnergyBuildingAnimation"
        }
      ],
      sixteenByNine: [
        {
          touchPointPosition: { top: "20%", left: "0%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "EnergyBuildingAnimation"
        }
      ]
    },
    zoneThree: {
      fiveByOne: [
        {
          touchPointPosition: { top: "3%", left: "25%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "smartTransportationInfrastructure"
        },
        {
          touchPointPosition: { top: "30%", left: "10%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "smartTransportationInfrastructureTwo"
        },
        {
          touchPointPosition: { top: "30%", left: "10%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "smartTransportationInfrastructureThree"
        }
      ],
      sixteenByNine: [
        {
          touchPointPosition: { top: "20%", left: "25%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "smartTransportationInfrastructure"
        },
        {
          touchPointPosition: { top: "40%", left: "10%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "smartTransportationInfrastructureTwo"
        },
        {
          touchPointPosition: { top: "40%", left: "10%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "smartTransportationInfrastructureThree"
        }
      ]
    },
    zoneFour: {
      fiveByOne: [
        {
          touchPointPosition: { top: "40%", left: "40%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "proactivePublicTransportAnimation"
        },
        {
          touchPointPosition: { top: "35%", left: "50%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "proactivePublicTransportAnimationTwo"
        },
        {
          touchPointPosition: { top: "30%", left: "60%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "proactivePublicTransportAnimationThree"
        }
      ],
      sixteenByNine: [
        {
          touchPointPosition: { top: "55%", left: "40%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "proactivePublicTransportAnimation"
        },
        {
          touchPointPosition: { top: "50%", left: "50%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "proactivePublicTransportAnimationTwo"
        },
        {
          touchPointPosition: { top: "45%", left: "60%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "proactivePublicTransportAnimationThree"
        }
      ]
    },

    zoneFive: {
      fiveByOne: [
        {
          touchPointPosition: { top: "15%", left: "75%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "trafficAnimation"
        },
        {
          touchPointPosition: { top: "5%", left: "57%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "trafficAnimationTwo"
        }
      ],
      sixteenByNine: [
        {
          touchPointPosition: { top: "25%", left: "75%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "trafficAnimation"
        },
        {
          touchPointPosition: { top: "15%", left: "57%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "trafficAnimationTwo"
        }
      ]
    },

    zoneSix: {
      fiveByOne: [
        {
          touchPointPosition: { top: "15%", left: "97%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "manufacturingOneAnimation"
        },
        {
          touchPointPosition: { top: "25%", left: "92%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "manufacturingOneAnimationTwo"
        },
        {
          touchPointPosition: { top: "20%", left: "95%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "manufacturingOneAnimationThree"
        },
        {
          touchPointPosition: { top: "5%", left: "97%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "bakery"
        }
      ],
      sixteenByNine: [
        {
          touchPointPosition: { top: "25%", left: "97%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "manufacturingOneAnimation"
        },
        {
          touchPointPosition: { top: "35%", left: "92%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "manufacturingOneAnimationTwo"
        },
        {
          touchPointPosition: { top: "30%", left: "95%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "manufacturingOneAnimationThree"
        },
        {
          touchPointPosition: { top: "15%", left: "97%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "bakery"
        }
      ]
    },
    zoneSeven: {
      fiveByOne: [
        {
          touchPointPosition: { top: "15%", left: "99%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "manufacturingTwoAnimation"
        }
      ],
      sixteenByNine: [
        {
          touchPointPosition: { top: "30%", left: "99%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "manufacturingTwoAnimation"
        }
      ]
    },

    zoneEight: {
      fiveByOne: [
        {
          touchPointPosition: { top: "15%", left: "38%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "healthCareOneAnimation"
        },
        {
          touchPointPosition: { top: "-8%", left: "43%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "healthCareOneAnimationTwo"
        }
      ],
      sixteenByNine: [
        {
          touchPointPosition: { top: "34%", left: "38%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "healthCareOneAnimation"
        },
        {
          touchPointPosition: { top: "13%", left: "43%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "healthCareOneAnimationTwo"
        }
      ]
    },
    zoneNine: {
      fiveByOne: [
        {
          touchPointPosition: { top: "-10%", left: "55%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "healthCareTwoAnimation"
        }
      ],
      sixteenByNine: [
        {
          touchPointPosition: { top: "3%", left: "55%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "healthCareTwoAnimation"
        }
      ]
    },

    zoneTen: {
      fiveByOne: [
        {
          touchPointPosition: { top: "-5%", left: "76%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "retailAnimation"
        }
      ],
      sixteenByNine: [
        {
          touchPointPosition: { top: "8%", left: "76%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "retailAnimation"
        }
      ]
    },
    zoneEleven: {
      fiveByOne: [
        {
          touchPointPosition: { top: "45%", left: "15%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "maritimeAnimation"
        }
      ],
      sixteenByNine: [
        {
          touchPointPosition: { top: "60%", left: "15%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "maritimeAnimation"
        }
      ]
    },
    zoneTwelve: {
      fiveByOne: [
        {
          touchPointPosition: { top: "0%", left: "95%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "surveillanceAnimation"
        },
        {
          touchPointPosition: { top: "10%", left: "95%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "surveillanceAnimationTwo"
        }
      ],
      sixteenByNine: [
        {
          touchPointPosition: { top: "13%", left: "95%" },
          touchPointSize: { height: "2vw", width: "2vw" },
          ref: "surveillanceAnimation"
        }
      ]
    }
  },
  browser: {
    zoneOne: [
      {
        touchPointPosition: { top: "58%", left: "11%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "buildingOneAnimation"
      },
      {
        touchPointPosition: { top: "53%", left: "11%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "buildingOneAnimationTwo"
      }
    ],
    zoneTwo: [
      {
        touchPointPosition: { top: "48%", left: "15%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "EnergyBuildingAnimation"
      }
    ],
    zoneThree: [
      {
        touchPointPosition: { top: "44%", left: "35%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "smartTransportationInfrastructure"
      },
      {
        touchPointPosition: { top: "53%", left: "24%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "smartTransportationInfrastructureTwo"
      },
      {
        touchPointPosition: { top: "54%", left: "36%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "smartTransportationInfrastructureThree"
      }
    ],
    zoneFour: [
      {
        touchPointPosition: { top: "63%", left: "44%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "proactivePublicTransportAnimation"
      },
      {
        touchPointPosition: { top: "58%", left: "50%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "proactivePublicTransportAnimationTwo"
      },
      {
        touchPointPosition: { top: "53%", left: "55%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "proactivePublicTransportAnimationThree"
      }
    ],
    zoneFive: [
      {
        touchPointPosition: { top: "48%", left: "61%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "trafficAnimation"
      },
      {
        touchPointPosition: { top: "42%", left: "57%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "trafficAnimationTwo"
      }
    ],
    zoneSix: [
      {
        touchPointPosition: { top: "44%", left: "90%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "manufacturingOneAnimation"
      },
      {
        touchPointPosition: { top: "58%", left: "75%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "manufacturingOneAnimationTwo"
      },
      {
        touchPointPosition: { top: "59%", left: "95%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "manufacturingOneAnimationThree"
      },
      {
        touchPointPosition: { top: "45%", left: "87%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "bakery"
      }
    ],
    zoneSeven: [
      {
        touchPointPosition: { top: "52%", left: "93%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "manufacturingTwoAnimation"
      }
    ],
    zoneEight: [
      {
        touchPointPosition: { top: "48%", left: "39.5%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "healthCareOneAnimation"
      },
      {
        touchPointPosition: { top: "40%", left: "43%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "healthCareOneAnimationTwo"
      }
    ],
    zoneNine: [
      {
        touchPointPosition: { top: "38%", left: "52%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "healthCareTwoAnimation"
      }
    ],
    zoneTen: [
      {
        touchPointPosition: { top: "40%", left: "65%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "retailAnimation"
      }
    ],
    zoneEleven: [
      {
        touchPointPosition: { top: "70%", left: "28%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "maritimeAnimation"
      },
      {
        touchPointPosition: { top: "65%", left: "18%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "maritimeAnimationTwo"
      },
      {
        touchPointPosition: { top: "70%", left: "38%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "maritimeAnimationThree"
      }
    ],
    zoneTwelve: [
      {
        touchPointPosition: { top: "43%", left: "75%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "surveillanceAnimation"
      },
      {
        touchPointPosition: { top: "48%", left: "80%" },
        touchPointSize: { height: "2vw", width: "2vw" },
        ref: "surveillanceAnimationTwo"
      }
    ]
  }
};
